import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl } from '../data/kit';
interface CtaButtonProps {
  label: string;
  href?: string;
  size?: 'md' | 'lg';
  fullWidth?: boolean;
}
export function CtaButton({
  label,
  href = checkoutUrl,
  size = 'lg',
  fullWidth = false
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-5 text-base sm:text-lg' : 'px-6 py-3.5 text-sm';
  return <a href={href} className={`group inline-flex items-center justify-center gap-3 whitespace-nowrap rounded-full bg-cta font-display font-extrabold uppercase tracking-wide text-cta-ink shadow-[0_5px_0_#b98500] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-cta-hover active:translate-y-[3px] active:shadow-[0_2px_0_#b98500] focus:outline-none focus-visible:ring-4 focus-visible:ring-ink/25 ${sizing} ${fullWidth ? 'w-full' : ''}`} data-id="element-95" data-mp="qjij7pi8gw0z">
      {label}
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-96" data-mp="15ahp2srop6gv" />
    </a>;
}